import { g as getUAString } from '../utils/userAgent-BFCR1Dso.js';

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

export { isLayoutViewport as i };
//# sourceMappingURL=isLayoutViewport-dvwbaDqh.js.map
